// admin/src/features/preview/WatchScreens.tsx
//
// The watch session's How-to page (targets/watch/Session/HowToPage.swift):
// eyebrow, exercise name, the still in a 118 pt (scaled per size) rounded
// box with scaledToFit -- so a photo is letterboxed, never cropped -- and
// the "Show on iPhone" pill. Tokens: targets/watch/Theme/Theme.swift.
import type { DeviceSpec } from './devices';
import { watchScaled } from './devices';
import { Glyph, sportGlyph } from './icons';

const P = {
  surface: '#16181D',
  border: '#272B33',
  textPrimary: '#F5F6F8',
  textSecondary: '#9BA1AE',
};

export function WatchHowToScreen({ device, name, sport, stillUrl, description }: { device: DeviceSpec; name: string; sport: string; stillUrl: string | null; description: string | null }) {
  const pad = device.widthPt < 180 ? 8 : 10;
  return (
    <div className="pv-watch-screen">
      <span className="pv-watch-time">10:09</span>
      <div className="pv-scroll" style={{ padding: `36px ${pad}px 10px` }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <span className="pv-watch-eyebrow">How-to</span>
          <span className="pv-watch-name">{name || 'Exercise'}</span>
          <div style={{ position: 'relative', flexShrink: 0, height: watchScaled(device, 118), borderRadius: 12, background: P.surface, overflow: 'hidden', display: 'grid', placeItems: 'center' }}>
            {stillUrl ? (
              <img src={stillUrl} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'contain' }} />
            ) : (
              <Glyph name={sportGlyph(sport)} size={34} color={P.textSecondary} />
            )}
          </div>
          {description ? <span className="pv-watch-caption">{description}</span> : null}
          <span className="pv-watch-pill">Show on iPhone</span>
        </div>
      </div>
    </div>
  );
}
